import { useState } from 'react'
import { JiraDataFilterRow, JiraFilterPreview } from 'models'
import { ProductsServiceV4 } from 'services/v4/products-v4.service'

/* Preview of the filter rows currently drafted in the section — run on demand,
 * against local state, with no need for the step to be applied first. */
export const useJiraFilterPreview = (productId?: string) => {
  const [preview, setPreview] = useState<JiraFilterPreview | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const runPreview = async (filters: JiraDataFilterRow[]) => {
    if (!productId) return

    setLoading(true)
    setError('')
    try {
      setPreview(await ProductsServiceV4.previewJiraIssues(productId, filters))
    } catch (e: any) {
      setPreview(null)
      setError(e?.response?.data?.message || 'Failed to generate the preview. Review your filters and try again.')
    } finally {
      setLoading(false)
    }
  }

  return { preview, loading, error, runPreview }
}
